import { tailwindVariants } from '@air/utils-tailwind';

export const agentDropdownMenuPanel = tailwindVariants({
  base: 'w-[288px] rounded-8 border-2 border-white/15 ads:bg-glass-menu/90 bg-surface-1/90 p-2 text-white shadow-popover backdrop-blur-[24px]',
});

export const agentDropdownMenuSubPanel = tailwindVariants({
  base: 'z-portal flex max-h-[var(--radix-dropdown-menu-content-available-height)] w-[288px] flex-col gap-2 overflow-y-auto rounded-8 border-2 border-white/15 ads:bg-glass-menu/90 bg-surface-1/90 p-2 text-white shadow-popover backdrop-blur-[24px]',
});

export const agentDropdownMenuItem = tailwindVariants({
  base: 'group/dropdown-menu-item radix-highlighted:bg-white/10 text-white/90 hover:bg-white/10 [&_span.text-12]:text-white/65 [&_svg]:text-current',
});

export const agentDropdownMenuSeparator = tailwindVariants({
  base: '-mx-2 bg-white/10',
});

export const agentDropdownMenuLabel = tailwindVariants({
  base: 'text-white/40',
});
